export const defaultLocale = 'en' as const
export const locales = ['en', 'es', 'fr'] as const
export type Locale = (typeof locales)[number]

export function isValidLocale(value: string): value is Locale {
  return locales.includes(value as Locale)
}

/**
 * Languages the pickers label "beta" while their translations are refined.
 * Spanish is the community's main language and not beta (audit M15); English
 * is the default. Empty this once French is production-confident.
 */
export const BETA_LOCALES: readonly Locale[] = ['fr']
